<template>
  <div class="include--col__wrapper col__whiteAbs" :class="[position]">
    <div class="include--col__content">
      <div
        class="include--col__top"
        :class="[data.iconClass]"
        :style="{
          backgroundColor: data.bgColor,
        }"
      >
        <div class="include--col__txt">
          <div v-if="data.best" class="include--col__best">
            {{ $t("common.bestSeller") }}
          </div>
          <div class="body-large include--col__tag" v-if="data.tag">
            {{ data.tag }}
          </div>
          <div class="h1 include--col__title txt-upper fw-bold">
            {{ data.name }}
          </div>
          <div class="body-large include--col__desc" v-if="data.desc">
            {{ data.desc }}
          </div>
        </div>

        <ImageWrapper
          :src="`https://s3.ap-southeast-1.amazonaws.com/nespresso.web/vertuo_pop/assets/images/${data.img}`"
          class="include--col__icon"
          :class="[data.iconClass]"
          alt=""
        />
      </div>
      <div class="include--col__collpase">
        <template v-if="data.content">
          <div
            class="include--col__collpase--trigger"
            @click="isOpen = !isOpen"
          >
            <div class="h2 txt-upper include--col__collpase--title">
              <div class="row">
                <div class="col">
                  <span v-html="data.content.collpaseTitle"></span>
                </div>
                <div class="col-auto">
                  <Icons
                    name="arrow_down"
                    class="include--col__collpase--arrow"
                    :class="{ isOpen }"
                  ></Icons>
                </div>
              </div>
            </div>
          </div>

          <collapse-transition>
            <div v-show="isOpen" class="include--col__collpase--content">
              <ImageWrapper
                :src="`https://s3.ap-southeast-1.amazonaws.com/nespresso.web/vertuo_pop/assets/images/${data.content.img}`"
                alt=""
                class="include--col__collpase--img"
                v-if="data.content.img"
              />
              <div class="include--col__collpase--desc">
                <div
                  class="h1 fw-bold include--col__subTitle"
                  v-if="data.content.title"
                >
                  {{ data.content.title }}
                </div>

                <div v-if="data.content.icons" class="mB24">
                  <div class="row">
                    <div
                      class="col-auto"
                      v-for="(item, index) in data.content.icons"
                    >
                      <div class="row include--col__icons--row">
                        <div class="col-auto">
                          <Icons
                            :name="item.icon"
                            class="include--col__icons--icon"
                          />
                        </div>
                        <div class="col-auto">
                          <div
                            class="h3 include--col__icons--icon--txt"
                            v-html="item.txt"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="data.content.ingredient" class="mB24">
                  <div
                    class="h3 txt-upper fw-bold include--col__ingredient mB8"
                  >
                    {{ $t("common.ingredient") }}
                  </div>

                  <div>
                    <div class="row include--col__in--row">
                      <div
                        class="col-6 col-md-auto"
                        v-for="(item, index) in data.content.ingredient"
                      >
                        <div class="include--col__in--col">
                          <ImageWrapper
                            :src="`https://s3.ap-southeast-1.amazonaws.com/nespresso.web/vertuo_pop/assets/images/${item.img}`"
                            alt=""
                            class="include--col__in--img"
                          />
                          <div class="include--col__in--txt">
                            <p
                              class="body-small fw-bold"
                              v-html="item.name"
                            ></p>
                            <p class="body-small" v-html="item.cap"></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="data.content.steps">
                  <div
                    class="row include--col__step--row"
                    v-for="(item, index) in data.content.steps"
                  >
                    <div class="col-auto text-center">
                      <div class="include--col__step--col">
                        <div
                          class="include--col__step--line"
                          :style="{ backgroundColor: data.bgColor }"
                          v-if="index != data.content.steps.length - 1"
                        ></div>

                        <div class="include--col__step">
                          <div class="body-small txt-upper">
                            {{ $t("common.step") }}
                          </div>
                          <div class="h1">0{{ index + 1 }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="col">
                      <p
                        class="body-large fw-bold include--col__step--txt"
                        v-html="item"
                      ></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </collapse-transition>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { Icons, ImageWrapper } from "~/components/";

import { CollapseTransition } from "@ivanv/vue-collapse-transition";

export default {
  name: "IncludeCol",
  components: {
    CollapseTransition,
    Icons,
    ImageWrapper,
  },

  props: {
    data: { type: Object },
    position: { type: String },
  },

  data() {
    return {
      isOpen: false, // closed by default
    };
  },
};
</script>

<style lang="scss">
@import "~/scss/include/_commonInclude.scss";

.content {
  .include--col {
    &__txt {
      font-weight: 700;
    }
    &__best {
      background-color: color(gold);
      font-size: rem(16);
      line-height: 1.2em;
      margin-bottom: rem(8);
      display: inline-block;
      padding: rem(2) rem(8);
      font-weight: 400;
      letter-spacing: 0.1em;

      @include media-breakpoint-down(md) {
        margin-bottom: rem(10);
        font-size: rem(12);
      }
    }

    &__tag,
    &__desc {
      @include media-breakpoint-down(md) {
        font-size: rem(12) !important;
      }
    }

    &__title {
      letter-spacing: 0.1em;
      line-height: 1.2em !important;
      font-size: rem(24) !important;
    }

    &__wrapper {
      width: 100%;
      // margin-bottom: rem(60);
      margin-bottom: 6.75rem;
      display: flex;

      @include media-breakpoint-down(lg) {
        margin-bottom: rem(60);
      }

      &.odd {
        justify-content: flex-end;
      }
    }

    &__subTitle {
      margin-bottom: rem(28);

      @include media-breakpoint-down(md) {
        font-size: rem(20) !important;
        line-height: 1.2em !important;
        margin-bottom: rem(8);
      }
    }

    &__ingredient {
      letter-spacing: 0.12em;

      @include media-breakpoint-down(md) {
        font-size: rem(14) !important;
        margin-bottom: rem(8) !important;
      }
    }

    &__in {
      &--row.row {
        --bs-gutter-x: #{rem(10)};
        --bs-gutter-y: #{rem(24)};
      }
      &--col {
        width: rem(150);
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        height: 100%;

        @include media-breakpoint-down(md) {
          width: 100%;
        }
      }

      &--img {
        width: rem(36);
        aspect-ratio: 1;
        object-fit: contain;
        margin-bottom: rem(8);
      }

      &--txt {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
    }

    &__icons {
      &--row.row {
        --bs-gutter-x: #{rem(10)};
      }
      &--icon {
        width: rem(24);
        aspect-ratio: 1;
        object-fit: contain;

        @include media-breakpoint-down(md) {
          width: rem(12);

          &--txt {
            font-size: rem(12) !important;
          }
        }
      }
    }

    &__step {
      background-color: color(black);
      position: relative;

      .h1 {
        line-height: 1em;
      }

      &--row {
        padding-top: 12px;
        padding-bottom: rem(24);
        overflow: hidden;
      }

      &--txt {
        @include media-breakpoint-down(md) {
          font-size: rem(14) !important;
          line-height: 1.2em !important;

          &.fw-bold {
            font-weight: 400 !important;
          }
        }
      }

      &--col {
        position: relative;
        margin-right: 12px;

        @include media-breakpoint-down(md) {
          margin-right: 5px;
        }
      }
      &--line {
        width: 1px;
        height: 100vh;
        display: block;
        background-color: white;
        position: absolute;
        left: 50%;
        top: 0;
      }
    }

    &__collpase {
      background-color: color(black);
      min-height: rem(60);
      display: flex;
      flex-direction: column;
      @include media-breakpoint-down(md) {
        min-height: 40px;
      }

      &--arrow {
        width: rem(24);
        height: 100%;
        object-fit: contain;
        transform: rotate(180deg);

        &.isOpen {
          transform: rotate(0deg);
        }
      }

      &--trigger {
        width: 100%;
        display: flex;
        align-items: center;
        min-height: rem(60);
        padding: rem(20) rem(10);
        cursor: pointer;

        @include media-breakpoint-down(md) {
          padding: rem(5) rem(10);
          min-height: rem(48);
        }
      }

      &--title {
        letter-spacing: 0.12em;
        @include media-breakpoint-down(md) {
          font-size: rem(16) !important;
          width: 100%;
          display: flex;
          justify-content: center;
        }
      }

      &--content {
      }

      &--img {
        width: 100%;
        height: rem(360);
        object-fit: cover;

        @include media-breakpoint-down(md) {
          height: rem(175);
        }
      }

      &--desc {
        padding: rem(40) 124/1118 * 100%;

        @include media-breakpoint-down(md) {
          padding: rem(24);
          padding-top: rem(16);
        }
      }
    }

    &__top {
      position: relative;
      padding-top: rem(24);
      padding-bottom: rem(24);
      display: flex;
      &.mug {
        height: rem(120);
        align-items: center;
        position: unset;
      }

      @include media-breakpoint-down(md) {
        padding-top: rem(16);
        padding-bottom: rem(16);
      }
    }

    &__content {
      // width: 1095/1440 * 100%;
      width: 78%;
      max-width: rem(1209);
      position: relative;

      @include media-breakpoint-down(lg) {
        width: calc(100% - 120px);
      }

      @include media-breakpoint-down(md) {
        width: 85%;
      }
    }

    &__icon {
      width: 300/1095 * 100%;
      min-width: rem(200);
      position: absolute;
      top: 0;

      @include media-breakpoint-down(md) {
        width: 40%;
        max-width: rem(200);
        min-width: inherit;
      }

      &.mug {
        width: inherit;
        height: calc(100% + 48px);
        transform: translate(50%, -50%);
        object-fit: contain;
        right: 0;
        top: 50%;
        position: absolute;
      }
    }
  }
}

:root {
  --deskop--col-padding-left: #{150/477 * 100%};
  --deskop--col-padding-left2: 36.092243%;

  // --deskop--col-padding-left: 20.446541%;
  // --deskop--col-padding-left2: 28.0922431866%;

  @include media-breakpoint-down(lg) {
    --deskop--col-padding-left: #{120/477 * 100%};
    --deskop--col-padding-left2: #{104/477 * 100%};
  }

  @include media-breakpoint-down(md) {
    --deskop--col-padding-left: #{130/477 * 100%};
    --deskop--col-padding-left2: #{94/477 * 100%};
  }
}

.odd {
  .include--col {
    &__collpase--desc {
      @include media-breakpoint-down(md) {
        padding-right: rem(45) !important;
      }
    }

    &__top {
      padding-left: var(--deskop--col-padding-left);
      justify-content: flex-start;
    }

    &__content {
      border-bottom-left-radius: rem(10);
    }

    &__icon {
      left: 0;
      transform: translate(-50%, -25%);

      @include media-breakpoint-down(md) {
        left: 5%;
      }
    }

    &__collpase {
      &--trigger {
        padding-left: var(--deskop--col-padding-left);

        @include media-breakpoint-down(md) {
          padding-left: rem(20);
          padding-right: rem(20);
        }
      }

      border-bottom-left-radius: 32px;
    }
  }
}

.even {
  .include--col {
    &__collpase--desc {
      @include media-breakpoint-down(md) {
        padding-left: rem(45) !important;
      }
    }
    &__top {
      padding-right: rem(100);
      padding-left: var(--deskop--col-padding-left2);

      @include media-breakpoint-down(md) {
        padding-right: rem(45);
      }
    }

    &__icon {
      right: 0;
      transform: translate(50%, -25%);
    }
    &__collpase {
      &--trigger {
        padding-left: var(--deskop--col-padding-left2);

        @include media-breakpoint-down(md) {
          padding-left: rem(20);
          padding-right: rem(20);
        }
      }

      border-bottom-right-radius: 32px;
    }
  }
}
</style>
&
